import { useState } from "react";
import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const fmt = (n) => n.toLocaleString("it-IT");

export const Compare = () => {
  const [monthly, setMonthly] = useState(500);
  const agencyYear = monthly * 12;
  const savings = agencyYear - 997;

  return (
    <section data-testid="compare-section" className="mx-auto max-w-6xl px-5 py-12">
      <Reveal>
        <div className="rounded-3xl border border-purple-100 bg-[#FAF8FF] p-6 sm:p-8">
          <div className="text-center">
            <h2 className="font-heading text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
              Fai due conti con noi
            </h2>
            <p className="mt-2 text-base text-slate-600">Quanto ti chiede (o ti chiederebbe) un'agenzia ogni mese?</p>
          </div>
          <div className="mt-6 flex items-center justify-center gap-5">
            <input
              data-testid="agency-cost-slider"
              type="range"
              min="200"
              max="1500"
              step="50"
              value={monthly}
              onChange={(e) => setMonthly(Number(e.target.value))}
              className="h-2 w-full max-w-md cursor-pointer accent-purple-600"
            />
            <span data-testid="agency-monthly-value" className="whitespace-nowrap font-heading text-xl font-extrabold text-slate-900">
              {fmt(monthly)}€<span className="text-sm font-semibold text-slate-400">/mese</span>
            </span>
          </div>

          <div className="mt-7 space-y-5">
            <div>
              <div className="mb-2 flex items-baseline justify-between">
                <span className="text-sm font-semibold text-slate-600">Agenzia tradizionale</span>
                <span data-testid="agency-yearly-value" className="font-heading text-lg font-extrabold text-red-500">
                  {fmt(agencyYear)}€/anno
                </span>
              </div>
              <div className="h-5 w-full overflow-hidden rounded-full bg-red-100">
                <motion.div
                  className="h-full rounded-full bg-red-500"
                  animate={{ width: "100%" }}
                  transition={{ duration: 0.5 }}
                />
              </div>
            </div>
            <div>
              <div className="mb-2 flex items-baseline justify-between">
                <span className="text-sm font-semibold text-slate-600">MIR-IA Starter Pack</span>
                <span className="font-heading text-lg font-extrabold text-purple-600">997€/anno</span>
              </div>
              <div className="h-5 w-full overflow-hidden rounded-full bg-purple-100">
                <motion.div
                  className="h-full rounded-full bg-purple-600"
                  animate={{ width: `${Math.max((997 / agencyYear) * 100, 6)}%` }}
                  transition={{ duration: 0.5 }}
                />
              </div>
            </div>
          </div>

          <p data-testid="savings-result" className="mt-6 text-center font-heading text-xl font-bold text-slate-900">
            Con MIR-IA risparmi <span className="text-purple-600">{fmt(savings)}€</span> ogni anno.
          </p>
        </div>
      </Reveal>
    </section>
  );
};
